var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("van-nav-bar", {
        attrs: { title: "行情", placeholder: "", fixed: "", border: false }
      }),
      _c(
        "div",
        { staticClass: "domainInfo" },
        [
          _c("div", { staticClass: "main" }, [
            _c("div", { staticClass: "logo" }, [
              _vm.notices.logo
                ? _c("img", { attrs: { src: _vm.notices.logo.url, alt: "" } })
                : _vm._e()
            ]),
            _c("div", { staticClass: "status" }, [
              _c("div", [_vm._v(_vm._s(_vm.timecenter))]),
              _c(
                "div",
                {
                  staticClass: "trade",
                  style: {
                    color: _vm.opentrade == true ? "#32BC77" : "#F94E3C",
                    border:
                      _vm.opentrade == true
                        ? "1px solid #32BC77"
                        : "1px solid #F94E3C"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.opentrade == true ? "开盘中" : "已停盘") +
                      " "
                  )
                ]
              )
            ])
          ]),
          _vm.notices.enable && _vm.noticesText
            ? _c("van-notice-bar", {
                attrs: {
                  text: _vm.noticesText,
                  "left-icon": require("@/assets/newImages/icon_notices_yellow_4@2x.png"),
                  background: "#252525",
                  color: "#ffffff",
                  speed: "60"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "van-pull-refresh",
        {
          staticStyle: { "background-color": "#252525" },
          attrs: { "success-text": "刷新成功" },
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.isLoading,
            callback: function($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading"
          }
        },
        [
          _vm.havedata
            ? _c("div", { staticClass: "totalwidth" }, [
                _c(
                  "div",
                  { staticClass: "productitems" },
                  [
                    _c("div", { staticClass: "header" }, [
                      _c("span", [_vm._v("现货价格")])
                    ]),
                    _c("ul", { staticClass: "flex ulflex topul" }, [
                      _c("li", { staticStyle: { flex: "2" } }, [
                        _vm._v("商品")
                      ]),
                      _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
                      _c("li", { staticClass: "navright" }, [_vm._v("销售")]),
                      _c("li", [_vm._v("高/低")])
                    ]),
                    _vm._l(_vm.arrcenter.spotPrice, function(items, index) {
                      return _c(
                        "div",
                        { key: items.engname, staticClass: "ulcenter" },
                        [
                          _c(
                            "ul",
                            {
                              staticClass: "flex ulflex productlist",
                              class:
                                index == _vm.arrcenter.huangjin.length - 1
                                  ? "lastul"
                                  : index == 0
                                  ? "firstul"
                                  : ""
                            },
                            [
                              _c("li", { staticClass: "flex_product" }, [
                                _vm._v(_vm._s(items.engname))
                              ]),
                              _vm.sendmsg
                                ? [
                                    _c(
                                      "li",
                                      {
                                        // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                        class:
                                          //   'huigou'
                                          // ] <= items.productData['huigou']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        items.productData["hgDisplay"] == "SHOW"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_x"
                                                    )(
                                                      items.productData[
                                                        "huigou"
                                                      ]
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : [_vm._v(" - ")]
                                      ],
                                      2
                                    ),
                                    _c(
                                      "li",
                                      {
                                        // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                        class:
                                          //   'xiaoshou'
                                          // ] <= items.productData['xiaoshou']
                                          //   ? 'redfont'
                                          //   : 'greenfont'
                                          items.productData["huigouColor"]
                                      },
                                      [
                                        items.productData["xsDisplay"] == "SHOW"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_x"
                                                    )(
                                                      items.productData[
                                                        "xiaoshou"
                                                      ]
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : [_vm._v(" - ")]
                                      ],
                                      2
                                    ),
                                    _c("li", { staticClass: "lastli" }, [
                                      _c(
                                        "div",
                                        {
                                          // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                          class:
                                            //   'high'
                                            // ] <= items.productData['high']
                                            //   ? 'redfont'
                                            //   : 'greenfont'
                                            items.productData["huigouColor"]
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("changeTwoDecimal_x")(
                                                  items.productData["high"]
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          // new_tuisong_val_before['huangjin'].prices[items['engname']][
                                          class:
                                            //   'low'
                                            // ] <= items.productData['low']
                                            //   ? 'redfont'
                                            //   : 'greenfont'
                                            items.productData["huigouColor"]
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("changeTwoDecimal_x")(
                                                  items.productData["low"]
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                : [
                                    _c(
                                      "li",
                                      { staticClass: "redfont" },
                                      [
                                        items.productData["hgDisplay"] == "SHOW"
                                          ? [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f(
                                                        "changeTwoDecimal_x"
                                                      )(
                                                        items.productData[
                                                          "huigou"
                                                        ]
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ])
                                            ]
                                          : [_vm._v(" - ")]
                                      ],
                                      2
                                    ),
                                    _c(
                                      "li",
                                      { staticClass: "redfont" },
                                      [
                                        items.productData["xsDisplay"] == "SHOW"
                                          ? [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f(
                                                      "changeTwoDecimal_x"
                                                    )(
                                                      items.productData[
                                                        "xiaoshou"
                                                      ]
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          : [_vm._v(" - ")]
                                      ],
                                      2
                                    ),
                                    _c("li", { staticClass: "lastli" }, [
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("changeTwoDecimal_x")(
                                              items.productData["high"]
                                            )
                                          )
                                        )
                                      ]),
                                      _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("changeTwoDecimal_x")(
                                              items.productData["low"]
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _c("div", { staticClass: "productitems" }, [
                  _c("div", { staticClass: "header" }, [
                    _c("span", [_vm._v("旧料价格")])
                  ]),
                  _c("ul", { staticClass: "flex ulflex topul" }, [
                    _c("li", { staticStyle: { flex: "2" } }, [_vm._v("商品")]),
                    _c("li", { staticClass: "navleft" }, [_vm._v("回购")]),
                    _c("li", { staticClass: "navright" }, [_vm._v("商品")]),
                    _c("li", [_vm._v("回购")])
                  ]),
                  _c("div", { staticClass: "oldProductlist" }, [
                    _c(
                      "div",
                      { staticStyle: { width: "50%" } },
                      _vm._l(_vm.arrcenter.huangjin, function(items, index) {
                        return (index !== 0) & (index !== 1)
                          ? _c(
                              "div",
                              {
                                key: items.productData["name"],
                                staticClass: "ulcenter"
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "flex ulflex productlist",
                                    class:
                                      index == _vm.arrcenter.huangjin.length - 1
                                        ? "lastul"
                                        : index == 1
                                        ? "firstul"
                                        : ""
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "flex_product textStyle" },
                                      [
                                        _vm._v(
                                          _vm._s(items.productData["name"])
                                        )
                                      ]
                                    ),
                                    _vm.sendmsg
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              class:
                                                items.productData["huigouColor"]
                                            },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "changeTwoDecimal_x"
                                                          )(
                                                            items.productData[
                                                              "huigou"
                                                            ]
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c(
                                            "li",
                                            { staticClass: "redfont" },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "changeTwoDecimal_x"
                                                            )(
                                                              items.productData[
                                                                "huigou"
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "50%" } },
                      _vm._l(_vm.arrcenter.baiyin, function(items, index) {
                        return (index !== 0) & (index !== 2)
                          ? _c(
                              "div",
                              {
                                key: items.productData["name"],
                                staticClass: "ulcenter"
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "flex ulflex productlist",
                                    class:
                                      index == _vm.arrcenter.baiyin.length - 1
                                        ? "lastul"
                                        : index == 0
                                        ? "firstul"
                                        : ""
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "flex_product textStyle" },
                                      [
                                        _vm._v(
                                          _vm._s(items.productData["name"])
                                        )
                                      ]
                                    ),
                                    _vm.sendmsg
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              class:
                                                items.productData["huigouColor"]
                                            },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "changeTwoDecimal_x"
                                                          )(
                                                            items.productData[
                                                              "huigou"
                                                            ]
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c(
                                            "li",
                                            { staticClass: "redfont" },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "changeTwoDecimal_x"
                                                            )(
                                                              items.productData[
                                                                "huigou"
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ]),
                  _c("div", { staticClass: "oldProductlist" }, [
                    _c(
                      "div",
                      { staticStyle: { width: "50%" } },
                      _vm._l(_vm.arrcenter.bojin, function(items, index) {
                        return (index !== 0) & (index !== 2)
                          ? _c(
                              "div",
                              {
                                key: items.productData["name"],
                                staticClass: "ulcenterCopy"
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "flex ulflex productlist",
                                    class:
                                      index == _vm.arrcenter.bojin.length - 1
                                        ? "lastul"
                                        : index == 1
                                        ? "firstul"
                                        : ""
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "flex_product textStyle" },
                                      [
                                        _vm._v(
                                          _vm._s(items.productData["name"])
                                        )
                                      ]
                                    ),
                                    _vm.sendmsg
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              class:
                                                items.productData["huigouColor"]
                                            },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "changeTwoDecimal_x"
                                                          )(
                                                            items.productData[
                                                              "huigou"
                                                            ]
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c(
                                            "li",
                                            { staticClass: "redfont" },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "changeTwoDecimal_x"
                                                            )(
                                                              items.productData[
                                                                "huigou"
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { staticStyle: { width: "50%" } },
                      _vm._l(_vm.arrcenter.bajin, function(items, index) {
                        return (index !== 0) & (index !== 2)
                          ? _c(
                              "div",
                              {
                                key: items.productData["name"],
                                staticClass: "ulcenterCopy"
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "flex ulflex productlist",
                                    class:
                                      index == _vm.arrcenter.bajin.length - 1
                                        ? "lastul"
                                        : index == 0
                                        ? "firstul"
                                        : ""
                                  },
                                  [
                                    _c(
                                      "li",
                                      { staticClass: "flex_product textStyle" },
                                      [
                                        _vm._v(
                                          _vm._s(items.productData["name"])
                                        )
                                      ]
                                    ),
                                    _vm.sendmsg
                                      ? [
                                          _c(
                                            "li",
                                            {
                                              class:
                                                items.productData["huigouColor"]
                                            },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "changeTwoDecimal_x"
                                                          )(
                                                            items.productData[
                                                              "huigou"
                                                            ]
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                      : [
                                          _c(
                                            "li",
                                            { staticClass: "redfont" },
                                            [
                                              items.productData["hgDisplay"] ==
                                              "SHOW"
                                                ? [
                                                    _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "changeTwoDecimal_x"
                                                            )(
                                                              items.productData[
                                                                "huigou"
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    )
                  ])
                ]),
                _c("div", { staticClass: "remark" }, [
                  _c("div", [
                    _vm.notices.tips
                      ? _c("div", { staticClass: "describe" }, [
                          _vm._v("温馨提示："),
                          _c("span", [_vm._v(_vm._s(_vm.notices.tips))])
                        ])
                      : _vm._e(),
                    _vm.notices.address
                      ? _c("div", { staticClass: "describe" }, [
                          _vm._v("地址："),
                          _c("span", [_vm._v(_vm._s(_vm.notices.address))])
                        ])
                      : _vm._e(),
                    _vm.notices.phone
                      ? _c("div", { staticClass: "describe" }, [
                          _vm._v("电话："),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.notices.phone) + "(微信请右侧扫码)"
                            )
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _c("img", {
                    staticStyle: { width: "105px", "margin-left": "5px" },
                    attrs: {
                      src: require("@/assets/images/kefu_jjj.png"),
                      alt: ""
                    }
                  })
                ])
              ])
            : _vm._e()
        ]
      ),
      _c(
        "van-popup",
        {
          staticStyle: { background: "transparent", width: "350px" },
          attrs: { "close-icon": "close" },
          on: { close: _vm.noticeClose },
          model: {
            value: _vm.showNotice,
            callback: function($$v) {
              _vm.showNotice = $$v
            },
            expression: "showNotice"
          }
        },
        [
          _c("img", { attrs: { src: _vm.noticeImg, alt: "" } }),
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("img", {
              staticStyle: { height: "40px", width: "40px" },
              attrs: {
                src: require("@/assets/images/close_notice.png"),
                alt: ""
              },
              on: { click: _vm.noticeClose }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }